<template>
    <div class="step-heading__container">
        <h2  v-if="currentStep.step !=='confirmation'" class="step-heading">
            <span v-if="currentStep.pills"
                >Step {{ currentStep.pills.item }} of
                {{ currentStep.pills.total }} - </span
            >{{ currentStep.label }}
        </h2>
        <h2  v-else class="step-heading">
            {{ currentStep.label }}
        </h2>
        <div class="step-bar">
            <span
                v-for="(step, index) in currentStep.pills.total"
                :key="index"
                class="step-bar__step"
                :class="{
                    'step-bar__step--clickable' : index < currentStep.pills.item - 1,
                    'step-bar__step--active': index === currentStep.pills.item - 1,
                }"
                @click="goToStep(step)"
            ></span>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    name: "Navigation",
    computed: {
        ...mapState(["navigator"]),
        ...mapGetters(["currentStep", "model"]),
    },
    methods: {
        goToStep(stepNumber) {
            if(this.currentStep !== undefined){
                if(stepNumber <= this.currentStep.pills.item){
                    this.$store.dispatch("navigatorStep", this.navigator.steps[stepNumber].previous)
                }
            }
        },
    }   
};
</script>

<style lang="scss" scoped>
.step-bar {
    display: flex;
    gap: 15px;
    &__step {
        flex: 1;
        height: 4px;
        background-color: #d1d1d1;
        border-radius: 16px;
        &--active {
            background-color:  #67CDAE;
        }
    }
}

.step-heading {
    margin: 0;
    font-size: 15px;
    color: #0093d6;
    font-weight: 600;
    margin-bottom: 12px;

    &__container {
        margin-top: 37px;
    }
}
</style>
